export default "__VITE_ASSET__DcLeQTYa__"